import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import logo from '../logo-horizontal.svg'

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
        <header>
            <div className="headingcontainer">    
                <div className="rowwrapper">
                    <img src={logo} alt="logo" />
                    </div>
         
            </div>
            <div className="headingcontainer">
                <div className="rowwrapper">
                    <h1>Digital Uplift Check (DUC) Tool</h1>                  
                    </div>
         
      
            </div>
      </header>
    );
  }
}
